import * as React from "react";
import {ExtraIncomeStore} from "../stores/extra_income";

export const ExtraIncomeStoreContext = React.createContext<ExtraIncomeStore | null>(null);
